import { Loader2 } from 'lucide-react';

const variants = {
  primary: 'btn-primary',
  secondary: 'btn-secondary',
  danger: 'btn-danger',
  'outline-primary': 'btn-outline-primary',
  'outline-danger': 'btn-outline-danger',
  link: 'btn-link',
  'link-primary': 'btn-link-primary',
  'link-secondary': 'btn-link-secondary',
  'link-success': 'btn-link-success',
  'link-danger': 'btn-link-danger',
};

const sizes = {
  sm: 'btn-sm',
  md: '',
  lg: 'btn-lg',
};

const Button = ({
  variant = 'primary',
  size = 'md',
  loading = false,
  disabled = false,
  type = 'button',
  onClick,
  className = '',
  children,
  ...rest
}) => (
  <button
    type={type}
    onClick={onClick}
    disabled={disabled || loading}
    className={`btn inline-flex items-center justify-center gap-2 disabled:opacity-60 disabled:pointer-events-none ${
      variants[variant] ?? variants.primary
    } ${sizes[size] ?? ''} ${className}`}
    {...rest}
  >
    {loading && <Loader2 className="w-4 h-4 animate-spin" aria-hidden="true" />}
    {children}
  </button>
);

export default Button;
